import React from "react";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import DetailSingleItem from "../DetailSingleItem";
import styled from "styled-components";

const OrderDetailItemNew = (props) => {
  const {
    orderItemDetails: {
      orderItems = [],
      expectedDeliveryDate = "",
      status = "",
      shipmentId = "",
    } = {},
    orderNumber = "",
  } = props;

  const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-family: 'Ancizar Sans', sans-serif;
  margin-bottom: 1rem;
  width: 100%;

  .list{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  }
  `
  const OrderContainerTop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  
  align-items: center;
  margin-bottom: 7px;
  width: 100%;

  
  `
  const OrderStatusTypography = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: 'Ancizar Sans', sans-serif;
  font-weight: 500;
  `

  return (
    
    <OrderContainer>
      <OrderContainerTop>
       {/*  <OrderStatusTypography>{`Status: ${status}`}</OrderStatusTypography> */}
        

        <div className="list">
          {orderItems.map((item, index) => {
           
          return (
            <DetailSingleItem
              key={index}
              itemDetails={item}
              orderNumber={orderNumber}
              expectedDeliveryDate={expectedDeliveryDate}
              shipmentId={shipmentId}
            />
          );

        })}
        </div>

      </OrderContainerTop>


    </OrderContainer>

   
  );
};

export default OrderDetailItemNew;
